<div
  class="simple-expand"
  [ngClass]="{
    transparent: variant === 'transparent',
    white: variant === 'white'
  }"
>
  <div
    class="simple-expand__title"
    [class.expanded]="isExpanded"
    (click)="toggleExpand($event)"
    (keydown.enter)="toggleExpand($event)"
    tabindex="0"
  >
    <div class="simple-expand__title__text">
      <ng-content select="[expand-title]"></ng-content>
    </div>
    <div class="simple-expand__title__expand">
      <ui-svg-icon
        [iconClassName]="
          isExpanded
            ? 'icon-shared--expand'
            : 'icon-shared--expand not-expanded'
        "
        svgId="arrow-up"
      ></ui-svg-icon>
    </div>
  </div>
  <div class="simple-expand__content" *ngIf="isExpanded">
    <ng-content select="[expand-content]"></ng-content>
  </div>
</div>
